module.exports = __webpack_public_path__ + "assets/apexchartsjs.9a70b04f.svg";